import React, { useState, useEffect, useContext } from "react";
import Main from "../../components/Main";
import TabelaDinamica from "../../components/TabelaDinamica";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import CRUDPageHeader from "../../components/CRUDPageHeader";
import {
  obterVerbas,
  obterVerbasPorCampoDeBusca,
} from "../../services/api-esocial.service";
import { handleErrorResponse } from "../../utils/error.util";
import { Context } from "src/config/AuthContext";
import { CurrencyExchange, } from "@mui/icons-material";
import { simplifyString } from "../../utils/simplify_string";

const Verbas = () => {
  const { handleLogout } = useContext(Context);

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [verbasData, setVerbasData] = useState([]);
  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);

  const [exportFilename, setExportFilename] = useState("");
  const [exportData, setExportData] = useState([]);
  
  const columns = [
    { id: "codigoRubrica", label: "Código da\nRubrica", field: "codigoRubrica_cellVal" },
    { id: "descricaoRubrica", label: "Descrição\nda Rubrica", field: "descricaoRubrica" },
    { id: "inicioValidade", label: "Inicio da\nValidade", field: "inicioValidade_cellVal" },
    { id: "fimValidade", label: "Fim (Calculado)\nda Validade", field: "fimValidade_cellVal" },
    { id: "tipoRubrica", label: "Tipo da\nRubrica", field: "tipoRubrica" },
    { id: "codigoIncidencia", label: "Código de\nIncidência", field: "codigoIncidencia" },
    { id: "descricaoIncidencia", label: "Descrição da\nIncidência", field: "descricaoIncidencia" },
    { id: "categoriaIncidencia", label: "Categoria da\nIncidência", field: "categoriaIncidencia" },
  ];

  const getVerbas = async (idEmpresa) => {
    try {
      const response = await obterVerbas(idEmpresa);
      const verbas = response.verbas;
      verbas.forEach(verba => {
        if (verba.codigoRubrica)
            verba.codigoRubrica_cellVal = simplifyString(verba.codigoRubrica)
        if (verba.inicioValidade)
          verba.inicioValidade_cellVal = verba.inicioValidade.split('-')[1] + '/' + verba.inicioValidade.split('-')[0];
        if (verba.fimValidade)
          verba.fimValidade_cellVal = verba.fimValidade.split('-')[1] + '/' + verba.fimValidade.split('-')[0];
      });
      setVerbasData(verbas);
    } catch (err) {
      handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout);
    }
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (!reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleDebouncerChange = async (event) => {
    setLoading(true);
    try {
      const response = await obterVerbasPorCampoDeBusca(idEmpresa, event.target.value);
      response.verbas.forEach(verba => {
        if (verba.codigoRubrica)
            verba.codigoRubrica_cellVal = simplifyString(verba.codigoRubrica)
        if (verba.inicioValidade)
          verba.inicioValidade_cellVal = verba.inicioValidade.split('-')[1] + '/' + verba.inicioValidade.split('-')[0];
        if (verba.fimValidade)
          verba.fimValidade_cellVal = verba.fimValidade.split('-')[1] + '/' + verba.fimValidade.split('-')[0];
      });
      setVerbasData(response.verbas);
    } catch (err) {
      if (err.response && err.response.status === 404) {
        setVerbasData([]);
      }
      else {
        handleErrorResponse(err, setMsg, handleOpenSnackbarErro, handleLogout)
      };
    }
    setLoading(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      if (idGrupoEconomico !== null && idEmpresa !== null) {
        setLoading(true);
        await getVerbas(idEmpresa);
        setLoading(false);
      } else {
        setLoading(true);
        setVerbasData([]);
        setLoading(false);
      }
    };

    fetchData();
    setExportFilename(getExportFilename(idEmpresa));
  }, [idEmpresa]);

  useEffect(() => {
    setExportData(setupExportData(verbasData));
  }, [verbasData]);

  const setupExportData = (verbas) => {
    var exportData = [];
    verbas.forEach((verba) => {
      exportData.push({
        "<style bold>Código da Rubrica</style>": verba.codigoRubrica,
        "<style bold>Descrição da Rubrica</style>": verba.descricaoRubrica,
        "<style bold>Inicio da Validade</style>": verba.inicioValidade_cellVal,
        "<style bold>Fim Calculado da Validade</style>": verba.fimValidade_cellVal,
        "<style bold>Tipo da Rubrica</style>": verba.tipoRubrica,
        "<style bold>Código de Incidência</style>": verba.codigoIncidencia,
        "<style bold>Descrição da Incidência</style>": verba.descricaoIncidencia,
        "<style bold>Categoria da Incidência</style>": verba.categoriaIncidencia,
      });
    });
    return exportData;
  }

  const handleGrupoECnpjChange = async (ids) => {
    setIdGrupoEconomico(ids.GE);
    setIdEmpresa(ids.CNPJ);
  }

  const getExportFilename = (cnpj) => {
    return "folhas_idEmpresa_"
      .concat(cnpj)
      .concat("_")
      .concat(
        new Date()
          .toISOString()
          .replace(/\.\d{3}/, "")
          .replace("T", " ")
          .replace("Z", "")
          .replaceAll(":", "-")
          .replace(" ", "_")
      );
  };

  return (
    <div>
      <Main />

      <CRUDPageHeader
        headerIcon={
          <CurrencyExchange fontSize="30px" />
        }
        headerTitle={"Verbas eSocial"}
        handleDebounceChange={handleDebouncerChange}
        AutoCompleteGrupoECnpj
        handleGrupoECnpjChange={handleGrupoECnpjChange}
        disableModalButton
      />

      <TabelaDinamica
        data={verbasData}
        columns={columns}
        loading={loading}
        exportFilename={exportFilename}
        exportData={exportData}
        disableEdit
        disableDelete
      />

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};

export default Verbas;
